import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import dropdown from '../components/dropdown';

gsap.registerPlugin(ScrollTrigger);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      textInputs: [...this.el.querySelectorAll('.FormTextbox__Input')],
      checkboxInputs: [...this.el.querySelectorAll('.FormChoice')],
      decorator: this.el.querySelector('.contact-us-form-full__decorator img'),
      condition: this.el.querySelector('.contact-us-form__condition'),
      countriesDropdown: this.el.querySelector('select[title="country"]'),
      topicsDropdown: this.el.querySelector(
        'select[title="topics-of-interest"]'
      ),
      dropdowns: this.el.querySelectorAll('select'),
      submitButton: this.el.querySelector('.FormSubmitButton'),
      honeypots: this.el.querySelectorAll('.honeypotelementblock')
    };

    this.dom.honeypots.forEach(row => {
      row.parentNode.style.margin = 0;
      row.parentNode.style.height = 0;
    });

    this.dom.checkboxInputs.forEach(input => {
      const check = document.createElement('span');
      check.classList.add('checkmark');
      const checkbox = input.querySelector('input');
      checkbox.parentNode.insertBefore(check, checkbox.nextSibling);
    });

    if (
      this.dom.condition &&
      this.dom.countriesDropdown &&
      this.dom.topicsDropdown
    ) {
      this.condition = JSON.parse(this.dom.condition.value);
      this.countriesDropdown = new dropdown(this.dom.countriesDropdown);
      this.topicsDropdown = new dropdown(this.dom.topicsDropdown);
      this.topicsDropdownPlaceholder = this.dom.topicsDropdown.querySelector(
        'option[value=""]'
      );

      this.populateTopicsOfInterest('');
    } else {
      this.dom.dropdowns.forEach(element => new dropdown(element));
    }

    if (this.dom.decorator) {
      this.initShapeAnimation();
    }

    if (this.dom.submitButton) {
      const label = this.dom.submitButton.innerHTML.trim();
      this.dom.submitButton.innerHTML = '';
      const btnInner = document.createElement('div');
      btnInner.classList.add('btn-content');
      const btnSpan = document.createElement('span');
      btnSpan.innerHTML = label;
      btnInner.appendChild(btnSpan);
      this.dom.submitButton.classList.add('btn-v2', 'btn--primary');
      this.dom.submitButton.appendChild(btnInner);
    }
  }

  addListeners() {
    this.dom.textInputs.forEach(input => {
      input.addEventListener('focus', this.handleTextInputFocus.bind(this));
      input.addEventListener('blur', this.handleTextInputBlur.bind(this));
      input.addEventListener('change', this.checkInputValue.bind(this));
      input.addEventListener('keyup', this.checkInputValue.bind(this));
    });

    if (
      this.dom.condition &&
      this.dom.countriesDropdown &&
      this.dom.topicsDropdown
    ) {
      this.countriesDropdown.on('option', e => {
        this.populateTopicsOfInterest(e.target.value);
      });
    }
  }

  populateTopicsOfInterest(name) {
    const topics = this.condition.find(cond => cond.Name === name)?.Topics;
    let options = '';

    if (topics) {
      options = topics
        .map(topic => `<option value="${topic}">${topic}</option>`)
        .join('');
    }

    this.dom.topicsDropdown.innerHTML = options;

    if (topics) {
      if (topics.length > 1 && this.topicsDropdownPlaceholder) {
        this.dom.topicsDropdown.prepend(this.topicsDropdownPlaceholder);
      }
    } else {
      this.dom.topicsDropdown.innerHTML = `<option value="">${this.el.dataset.conditionOption}</option>`;
    }

    this.topicsDropdown.update();
  }

  handleTextInputFocus(e) {
    e.target.parentNode.classList.add('is-focused');
  }

  handleTextInputBlur(e) {
    e.target.parentNode.classList.remove('is-focused');
  }

  checkInputValue(e) {
    if (e.target.value) {
      e.target.parentNode.classList.add('is-filled');
    } else {
      e.target.parentNode.classList.remove('is-filled');
    }
  }

  initShapeAnimation() {
    gsap.from(this.dom.decorator, {
      scrollTrigger: {
        trigger: this.el,
        end: 'top 25%',
        scrub: true
      },
      opacity: 0,
      scale: 0.65,
      rotation: -20
    });
  }
}

export default Module;
